export const DEFAULT_EMPLOYEE_CONFIG = [
  {
    label: "First Name",
    value: "first_name",
  },
  {
    label: "Last Name",
    value: "last_name",
  },
  {
    label: "Mobile Number",
    value: "mobile_number",
  },
  {
    label: "Email",
    value: "email",
  },
  {
    label: "Salary",
    value: "salary",
  },
  {
    label: "Bank Name",
    value: "bank_name",
  },
  {
    label: "Bank Branch Name",
    value: "bank_branch_name",
  },
  {
    label: "Bank Branch Code",
    value: "bank_branch_code",
  },
  {
    label: "Bank Account Number",
    value: "bank_account_number",
  },
  {
    label: "Pay Cycle ID",
    value: "employee_pay_cycle_id",
  },
  {
    label: "Employee Branch ID",
    value: "employee_branch_id",
  },
  {
    label: "Employee Branch Code",
    value: "employee_branch_code",
  },
  {
    label: "Employee Branch Name",
    value: "employee_branch_name",
  },
  {
    label: "Identification Number",
    value: "id_number",
  },
  {
    label: "Employee Number",
    value: "employee_no",
  },
  {
    // The label only. `smartwage_status` is the monolith's column name and stays.
    label: "Jem Status",
    value: "smartwage_status",
  },
];
